module.exports = __webpack_public_path__ + "static/media/20.7fa040ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/rhand/20.png
// module id = 938
// module chunks = 0